var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && _vm.companies.length)?_c('div',{staticClass:"vatin-box"},[_c('span',[_vm._v(_vm._s(_vm.bundle.id_12055))]),_vm._l((_vm.companies),function(c){return _c('a',{key:c.vatin,attrs:{"href":_vm.watchUrl(c)}},[_vm._v(" "+_vm._s(c.name)+" ")])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }